<template>
  <div class="container-inputtag">
    <b-form-tags
      v-model="input"
      :placeholder="$t('placeholder.addtags')"
      :addButtonText="$t('button.add')"
      :duplicateTagText="$t('message.duplicatetag')"
      :disabled="disabled"
      removeOnDelete
    />
  </div>
</template>

<script>
export default {
  props: ['value', 'disabled'],

  data () {
    return {
      input: null,
    }
  },

  watch: {
    input () {
      this.$emit('input', this.input)
    },
    value () {
      this.input = this.value
    },
  },

  created () {
    this.input = this.value
  },
}
</script>

<style scoped>
.container-inputtag /deep/ .b-form-tags.disabled {
  background-color: #e9ecef;
}

.container-inputtag /deep/ .b-form-tags.disabled .b-form-tag {
  min-height: 18px;
  background-color: #bcc2c7;
}

.container-inputtag /deep/ .b-form-tag {
  align-items: center !important;
  padding: 0 8px 0 8px;
  margin-right: 8px;
  min-height: 24px;
  line-height: normal;
}

.container-inputtag /deep/ .b-form-tag-content {
  position: relative;
  top: -1px;
  margin-right: 3px;
}

.container-inputtag /deep/ .b-form-tag-remove {
  position: relative;
  top: -1px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseInputTag.vue